module.exports = __webpack_public_path__ + "static/media/hardCap.470c67b2.png";